/* unplugin-vue-components disabled */import script from "./HotelFacilitieManager.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelFacilitieManager.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__